import React from "react";
import Box from "./base/Box";

const ProfanityLabel = ({ value = null, sx, ...props }) => {
  let labelColors = {};
  let label = "-";
  switch (value) {
    case true:
      labelColors = {
        color: "#a90202",
        backgroundColor: "#ffd0d0",
      };
      label = "Yes";
      break;
    case false:
      labelColors = {
        color: "#14804A",
        backgroundColor: "#bdffde",
      };
      label = "No";
      break;
    default:
      labelColors = {
        color: "darkslategray",
        backgroundColor: "lightgray",
      };
      label = "-";
  }

  return (
    <Box
      sx={{
        textAlign: "center",
        borderRadius: 20,
        textTransform: "capitalize",
        padding: "5px 10px",
        width: "fit-content",
        ...labelColors,
        ...sx,
      }}
      {...props}
    >
      {label}
    </Box>
  );
};

export default ProfanityLabel;
